/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import {register2} from '../core/_requests'
import {Link, Route} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_heomoney/helpers'
import {PasswordMeterComponent} from '../../../../_heomoney/assets/ts/components'
import {useAuth} from '../core/Auth'
import {useIntl} from 'react-intl'
import {sha256} from 'js-sha256'
import {useNavigate} from 'react-router-dom'
import {TextLinkModal} from '../../../../_heomoney/partials/modals/textlink-modal/TextLinkModal'
import emailjs from 'emailjs-com'
import axios from 'axios'

const initialValues = {
  firstname: '',
  firstname2: '',
  lastname: '',
  lastname2: '',
  birthdate: '20/03/1998',
  email: '',
  password: '',
  changepassword: '',
  acceptTerms: false,
}

interface DataItem {
  message: {
    msg_id: string
    msg_text: string
  }
  registro: [
    {
      iso2pais: string
      nombre: string
      phonecode: string
      moneda: string
    }
  ]
}

const YOUR_USER_ID = 'IeZj3UCntaQLwHqmW'
const YOUR_TEMPLATE_ID = 'template_fw65yjd'
const YOUR_SERVICE_ID = 'service_6d05m59'
const sendEmail = (values: any) => {
  // Evaluate condition before sending email
  // Send email using emailjs
  emailjs.send(
    YOUR_SERVICE_ID,
    YOUR_TEMPLATE_ID,
    {
      email: values.email,
      name: values.firstname,
      lastname: values.lastname,
      code: values.code,
    },
    YOUR_USER_ID
  )
}

export function Registration() {
  const [loading, setLoading] = useState(false)
  const [msg, setMsg] = useState('')
  const [showtextLinkModal, setShowTextLinkModal] = useState<boolean>(false)
  const navigate = useNavigate()
  const [date, setDate] = useState('2000-01-01')
  const [dateForm, setDateForm] = useState('30/03/2000')
  const [pais, setPais] = useState('')
  const [dataPais, setDataPais] = useState({
    registro: [
      {
        iso2pais: '',
        nombre: '',
        phonecode: '',
        moneda: '',
      },
    ],
  })
  // const {saveAuth, setCurrentUser} = useAuth()
  const intl = useIntl()

  const cambiarpais = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setPais(e.target.value)
    console.log(e.target.value)
  }

  const cambiarfecha = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDate(e.target.value) // Actualizar el estado con el valor seleccionado
    setDateForm(cambiarFormatoFecha(date))
    console.log(date)
    console.log(dateForm)
  }

  const cambiarFormatoFecha = (fecha: string) => {
    const fechaPartes = fecha.split('-') // Dividir la fecha en partes: año, mes, día
    const dia = fechaPartes[2]
    const mes = fechaPartes[1]
    const anio = fechaPartes[0]

    return `${dia}/${mes}/${anio}` // Combinar las partes en el formato deseado
  }

  const registrationSchema = Yup.object().shape({
    firstname: Yup.string()
      .min(3, intl.formatMessage({id: 'LOGIN.VALIDATION.EMAILMIN'}))
      .max(50, intl.formatMessage({id: 'LOGIN.VALIDATION.EMAILMAX'}))
      .required(intl.formatMessage({id: 'LOGIN.VALIDATION.FIRSTNAMEREQUIRED'})),
    firstname2: Yup.string()
      .min(3, intl.formatMessage({id: 'LOGIN.VALIDATION.EMAILMIN'}))
      .max(50, intl.formatMessage({id: 'LOGIN.VALIDATION.EMAILMAX'}))
      .required(intl.formatMessage({id: 'LOGIN.VALIDATION.FIRSTNAMEREQUIRED'})),
    email: Yup.string()
      .email(intl.formatMessage({id: 'LOGIN.VALIDATION.EMAILFORMAT'}))
      .min(3, intl.formatMessage({id: 'LOGIN.VALIDATION.EMAILMIN'}))
      .max(50, intl.formatMessage({id: 'LOGIN.VALIDATION.EMAILMAX'}))
      .required(intl.formatMessage({id: 'LOGIN.VALIDATION.EMAILREQUIRED'})),
    lastname: Yup.string()
      .min(3, intl.formatMessage({id: 'LOGIN.VALIDATION.EMAILMIN'}))
      .max(50, intl.formatMessage({id: 'LOGIN.VALIDATION.EMAILMAX'}))
      .required(intl.formatMessage({id: 'LOGIN.VALIDATION.LASTNAMEREQUIRED'})),
    lastname2: Yup.string()
      .min(3, intl.formatMessage({id: 'LOGIN.VALIDATION.EMAILMIN'}))
      .max(50, intl.formatMessage({id: 'LOGIN.VALIDATION.EMAILMAX'}))
      .required(intl.formatMessage({id: 'LOGIN.VALIDATION.LASTNAMEREQUIRED'})),
    birthdate: Yup.string().required('La fecha de nacimiento es requerida'),
    password: Yup.string()
      .min(3, intl.formatMessage({id: 'LOGIN.VALIDATION.PASSWORDMIN'}))
      .max(50, intl.formatMessage({id: 'LOGIN.VALIDATION.PASSWORDMAX'}))
      .required(intl.formatMessage({id: 'LOGIN.VALIDATION.PASSWORDREQUIRED'})),
    changepassword: Yup.string()
      .required(intl.formatMessage({id: 'LOGIN.VALIDATION.PASSWORDCREQUIRED'}))
      .when('password', {
        is: (val: string) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref('password')],
          intl.formatMessage({id: 'VALIDATION.PASSWORDC'})
        ),
      }),
    acceptTerms: Yup.bool().required('You must accept the terms and conditions'),
  })

  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        console.log(pais)
        const {data: Register} = await register2(
          values.lastname,
          values.lastname2,
          values.firstname,
          values.firstname2,
          values.email,
          dateForm,
          sha256(process.env.REACT_APP_SALT + sha256(values.password)),
          pais,
          'backOffice',
          intl.locale.toUpperCase()
        )
        console.log(Register.cod_gen?.code_gen)
        if (Register.msg_id == '0') {
          // setStatus(Register.txt_msg);
          setMsg(Register.msg_txt ? Register.msg_txt : 'Usuario registrado con exito')
          // const {data: RecuperarActive} = await getCodeActive(values.email)
          // console.log(RecuperarActive);
          // sendEmail({email:values.email,firstname:values.firstname,lastname:values.lastname,code:RecuperarActive.codeSession})
        } else if (Register.msg_id == '1') {
          // setStatus(Register.txt_msg)
          setMsg(`Error : ${Register.msg_txt}`)
          setTimeout(() => {
            window.location.reload()
          }, 3000)
          setSubmitting(false)
          setLoading(false)
        }

        // saveAuth(auth)
        // const {data: user} = await getUserByToken(auth.api_token)
        // setCurrentUser(user)
      } catch (error) {
        console.error(error)
        // saveAuth(undefined)
      }
    },
  })

  let fechaHoy

  useEffect(() => {
    PasswordMeterComponent.bootstrap()

    axios
      .post<DataItem>(`${process.env.REACT_APP_API_URL2}/cat_Pais/Read_All`, {
        cantidad_max: '0',
        language: intl.locale.toUpperCase(),
        filters: [
          {
            campo: 'iso2pais',
            operador: 'EQ',
            valor1: '',
            valor2: '',
            tipo: 'string',
          },
        ],
      })
      .then((response) => {
        // Actualizar el estado dataList con los datos obtenidos
        setDataPais(response.data)
      })
      .catch((error) => {
        console.error(error)
      })

    const obtenerFechaHoy = () => {
      const fecha = new Date()
      const dia = fecha.getDate().toString().padStart(2, '0')
      const mes = (fecha.getMonth() + 1).toString().padStart(2, '0')
      const anio = fecha.getFullYear().toString().slice(-2)
      return `${dia}/${mes}/${anio}`
    }

    fechaHoy = obtenerFechaHoy()
    console.log(fechaHoy)
  }, [])

  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_signup_form'
      onSubmit={formik.handleSubmit}
    >
      {/* Modal al registrarse */}
      <TextLinkModal
        show={showtextLinkModal}
        handleClose={() => {
          setShowTextLinkModal(false)
        }}
        text={msg}
        link={msg.includes('Error') ? '/auth/registration' : '/auth/login'}
        showbtn={msg.includes('Error') ? false : true}
      />

      {/* begin::Heading */}
      <div className='text-center mb-11'>
        {/* begin::Title */}
        <h1 className='text-dark fw-bolder mb-3'>{intl.formatMessage({id: 'REGISTER.TITLE'})}</h1>
        {/* end::Title */}

        <div className='text-gray-500 fw-semibold fs-6'>
          {intl.formatMessage({id: 'LOGIN.TEXT2'})}
        </div>
      </div>
      {/* end::Heading */}

      {/* begin::Login options */}
      <div className='row g-3 mb-9'>
        {/* begin::Col */}
        <div className='col-md-6'>
          {/* begin::Google link */}
          <a
            href='#'
            className='btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100'
          >
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/svg/brand-logos/google-icon.svg')}
              className='h-15px me-3'
            />
            {intl.formatMessage({id: 'LOGIN.GOOGLE'})}
          </a>
          {/* end::Google link */}
        </div>
        {/* end::Col */}

        {/* begin::Col */}
        <div className='col-md-6'>
          {/* begin::Google link */}
          <a
            href='#'
            className='btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100'
          >
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/svg/brand-logos/apple-black.svg')}
              className='theme-light-show h-15px me-3'
            />
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/svg/brand-logos/apple-black-dark.svg')}
              className='theme-dark-show h-15px me-3'
            />
            {intl.formatMessage({id: 'LOGIN.APPLE'})}
          </a>
          {/* end::Google link */}
        </div>
        {/* end::Col */}
      </div>
      {/* end::Login options */}

      <div className='separator separator-content my-14'>
        <span className='w-125px text-gray-500 fw-semibold fs-7'>
          {intl.formatMessage({id: 'LOGIN.TEXT3'})}
        </span>
      </div>

      {/* {formik.status && (
        <div className='mb-lg-15 alert alert-success'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )} */}

      {/* begin::Form group Firstname */}
      <div className='fv-row mb-8'>
        <label className='form-label fw-bolder text-dark fs-6'>Primer nombre</label>
        <input
          placeholder='Primer nombre'
          type='text'
          autoComplete='off'
          {...formik.getFieldProps('firstname')}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': formik.touched.firstname && formik.errors.firstname,
            },
            {
              'is-valid': formik.touched.firstname && !formik.errors.firstname,
            }
          )}
        />
        {formik.touched.firstname && formik.errors.firstname && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.firstname}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group Firstname2 */}
      <div className='fv-row mb-8'>
        <label className='form-label fw-bolder text-dark fs-6'>Segundo nombre</label>
        <input
          placeholder='Segundo nombre'
          type='text'
          autoComplete='off'
          {...formik.getFieldProps('firstname2')}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': formik.touched.firstname2 && formik.errors.firstname2,
            },
            {
              'is-valid': formik.touched.firstname2 && !formik.errors.firstname2,
            }
          )}
        />
        {formik.touched.firstname2 && formik.errors.firstname2 && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.firstname2}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}
      <div className='fv-row mb-8'>
        {/* begin::Form group Lastname */}
        <label className='form-label fw-bolder text-dark fs-6'>Apellido paterno</label>
        <input
          placeholder='Apellido paterno'
          type='text'
          autoComplete='off'
          {...formik.getFieldProps('lastname')}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': formik.touched.lastname && formik.errors.lastname,
            },
            {
              'is-valid': formik.touched.lastname && !formik.errors.lastname,
            }
          )}
        />
        {formik.touched.lastname && formik.errors.lastname && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.lastname}</span>
            </div>
          </div>
        )}
        {/* end::Form group */}
      </div>

      <div className='fv-row mb-8'>
        {/* begin::Form group apellido materno */}
        <label className='form-label fw-bolder text-dark fs-6'>Apellido materno</label>
        <input
          placeholder='Apellido materno'
          type='text'
          autoComplete='off'
          {...formik.getFieldProps('lastname2')}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': formik.touched.lastname2 && formik.errors.lastname2,
            },
            {
              'is-valid': formik.touched.lastname2 && !formik.errors.lastname2,
            }
          )}
        />
        {formik.touched.lastname2 && formik.errors.lastname2 && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.lastname2}</span>
            </div>
          </div>
        )}
        {/* end::Form group */}
      </div>

      {/* input de fecha */}
      <div className='fv-row' style={{marginBottom: '1rem'}}>
        <label className='form-label fw-bolder text-dark fs-6 mb-2'>
          <b>Fecha de nacimiento</b>
          <br />
        </label>
        <input
          type='date'
          autoComplete='on'
          {...formik.getFieldProps('birthdate')}
          className='form-control bg-transparent'
          onChange={cambiarfecha}
          value={date}
        />
        {formik.touched.birthdate && formik.errors.birthdate && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.birthdate}</span>
            </div>
          </div>
        )}
      </div>

      {/* begin::Form group fechanacimiento */}
      {/* <div className='fv-row mb-8'>
        <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({id: 'LOGIN.TEXT.LABELEMAIL'})}</label>
        <input
          placeholder={intl.formatMessage({id: 'LOGIN.TEXT.LABELEMAIL'})}
          type='email'
          autoComplete='on'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control bg-transparent',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div> */}
      {/* end::Form group */}

      {/* begin::Form group Email */}
      <div className='fv-row mb-8'>
        <label className='form-label fw-bolder text-dark fs-6'>
          {intl.formatMessage({id: 'LOGIN.TEXT.LABELEMAIL'})}
        </label>
        <input
          placeholder={intl.formatMessage({id: 'LOGIN.TEXT.LABELEMAIL'})}
          type='email'
          autoComplete='on'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control bg-transparent',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group Password */}
      <div className='fv-row mb-8' data-kt-password-meter='true'>
        <div className='mb-1'>
          <label className='form-label fw-bolder text-dark fs-6'>
            {intl.formatMessage({id: 'LOGIN.TEXT.LABELCONTRASEÑA'})}
          </label>
          <div className='position-relative mb-3'>
            <input
              type='password'
              placeholder={intl.formatMessage({id: 'LOGIN.TEXT.LABELCONTRASEÑA'})}
              autoComplete='off'
              {...formik.getFieldProps('password')}
              className={clsx(
                'form-control bg-transparent',
                {
                  'is-invalid': formik.touched.password && formik.errors.password,
                },
                {
                  'is-valid': formik.touched.password && !formik.errors.password,
                }
              )}
            />
            {formik.touched.password && formik.errors.password && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.password}</span>
                </div>
              </div>
            )}
          </div>
          {/* begin::Meter */}
          <div
            className='d-flex align-items-center mb-3'
            data-kt-password-meter-control='highlight'
          >
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px'></div>
          </div>
          {/* end::Meter */}
        </div>
        {/* <div className='text-muted'>
          Use 8 or more characters with a mix of letters, numbers & symbols.
        </div> */}
      </div>
      {/* end::Form group */}

      {/* begin::Form group Confirm password */}
      <div className='fv-row mb-5'>
        <label className='form-label fw-bolder text-dark fs-6'>
          {intl.formatMessage({id: 'LOGIN.TEXT.LABELCPASSWORD'})}
        </label>
        <input
          type='password'
          placeholder={intl.formatMessage({id: 'LOGIN.TEXT.LABELCPASSWORD'})}
          autoComplete='off'
          {...formik.getFieldProps('changepassword')}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': formik.touched.changepassword && formik.errors.changepassword,
            },
            {
              'is-valid': formik.touched.changepassword && !formik.errors.changepassword,
            }
          )}
        />
        {formik.touched.changepassword && formik.errors.changepassword && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.changepassword}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      <div className='fv-row mb-8 justify-content-between'>
        <label className='form-label fw-bolder text-dark fs-6'>País</label>
        <select className='form-select' value={pais} onChange={cambiarpais}>
          <option value=''>Seleccionar país de nacimiento</option>
          {dataPais.registro.map((data) => (
            <option key={data.iso2pais} value={data.iso2pais}>
              {data.nombre}
            </option>
          ))}
        </select>
      </div>

      {/* begin::Form group */}
      <div className='fv-row mb-8'>
        <label className='form-check form-check-inline' htmlFor='kt_login_toc_agree'>
          <input
            className='form-check-input'
            type='checkbox'
            id='kt_login_toc_agree'
            {...formik.getFieldProps('acceptTerms')}
          />
          <span>
            {intl.formatMessage({id: 'REGISTER.TERMS1'})}{' '}
            <a
              href='https://keenthemes.com/metronic/?page=faq'
              target='_blank'
              className='ms-1 link-primary'
            >
              {intl.formatMessage({id: 'REGISTER.TERMS2'})}
            </a>
            .
          </span>
        </label>
        {formik.touched.acceptTerms && formik.errors.acceptTerms && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.acceptTerms}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='text-center'>
        {}
        <button
          type='submit'
          id='kt_sign_up_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid || !formik.values.acceptTerms || !pais}
          onClick={() => setShowTextLinkModal(true)}
        >
          {!loading && (
            <span className='indicator-label'>
              {intl.formatMessage({id: 'AUTH.GENERAL.SUBMIT_BUTTON'})}
            </span>
          )}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              {intl.formatMessage({id: 'LOGIN.BTNWAIT'})}{' '}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>

        <Link to='/auth/login'>
          <button
            type='button'
            id='kt_login_signup_form_cancel_button'
            className='btn btn-lg btn-light-primary w-100 mb-5'
          >
            {intl.formatMessage({id: 'TEXT.CANCEL'})}
          </button>
        </Link>
      </div>
      {/* end::Form group */}
    </form>
  )
}
